import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, getToken, setToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    // If returning from Emergent Google OAuth, let AuthCallback handle it.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    if (!getToken()) {
      setUser(false); setLoading(false); return;
    }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setToken("");
      setUser(false);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password, remember = false) => {
    const r = await api.post("/auth/login", { email, password, remember });
    if (r.data.session_token) setToken(r.data.session_token);
    setUser(r.data);
    return r.data;
  };
  const register = async (email, password, name) => {
    // Returns { needs_verification, email, verification_url } — no session until verified.
    const r = await api.post("/auth/register", { email, password, name, origin: window.location.origin });
    return r.data;
  };
  const verifyEmail = async (token) => {
    const r = await api.post("/auth/verify-email", { token });
    if (r.data.session_token) setToken(r.data.session_token);
    setUser(r.data);
    return r.data;
  };
  const resendVerification = (email) => api.post("/auth/resend-verification", { email, origin: window.location.origin }).then((r) => r.data);
  const forgotPassword = (email) => api.post("/auth/forgot-password", { email, origin: window.location.origin }).then((r) => r.data);
  const resetPassword = (token, password) => api.post("/auth/reset-password", { token, password }).then((r) => r.data);
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setToken("");
    setUser(false);
  };
  const refresh = async () => {
    try { const r = await api.get("/auth/me"); setUser(r.data); }
    catch { setToken(""); setUser(false); }
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, verifyEmail, resendVerification, forgotPassword, resetPassword, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
